'use strict';

const storage = require('./storage-helper');

const {
  isClickFromDirectLink,
  updateDirectLink,
  isClickFromCouponWithNoCode,
} = require('./tracking-helper');
const { waitOnEvent } = require('./event-helper');
const { publish } = require('./event-observer');

function handleEvent(event) {
  if (event.type === 'click') {
    if (isClickFromDirectLink(event.widgets)) {
      updateDirectLink(event.widgets, event.id);
    } else if (isClickFromCouponWithNoCode(event.widgets)) {
      publish('click', event.id);
    } else {
      storage.setItem('eventId', event.id);
    }
  }
}

window.onload = function () {
  waitOnEvent({
    doneCheck: () =>
      !!window.OptimizeSuite && !!window.OptimizeSuite.bloodhound,
    callback: () => window.OptimizeSuite.bloodhound.on('event', handleEvent),
    fallback: handleEvent,
  });
};
